var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGroupOfPeopleYellow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "44px",
    viewBox: "0 0 50 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.108752, 0.091352)",
    fill: "#FFCC00"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    opacity: 0.4,
    transform: "translate(0.000000, 10.179178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,10.744688 C0,11.0568495 0.253348434,11.3101979 0.565509896,11.3101979 L3.95856927,11.3101979 L3.95856927,16.399787 C3.95856927,16.7119485 4.21191771,16.9652969 4.52407917,16.9652969 L9.04815834,16.9652969 C9.36031981,16.9652969 9.61366824,16.7119485 9.61366824,16.399787 L9.61366824,11.3101979 L13.0067276,11.3101979 C13.3188891,11.3101979 13.5722375,11.0568495 13.5722375,10.744688 C13.5722375,4.7197456 10.5908693,0 6.78611876,0 C2.98136817,0 0,4.7197456 0,10.744688 Z",
    id: "Fill-3093"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    opacity: 0.4,
    transform: "translate(22.357741, 0.208804)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(2.262040, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.52407917,9.04815834 C7.01910883,9.04815834 9.04815834,7.01910883 9.04815834,4.52407917 C9.04815834,2.02904951 7.01910883,0 4.52407917,0 C2.02904951,0 0,2.02904951 0,4.52407917 C0,7.01910883 2.02904951,9.04815834 4.52407917,9.04815834",
    id: "Fill-3092"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,20.9238662 C0,21.2360276 0.253348434,21.4893761 0.565509896,21.4893761 L3.95856927,21.4893761 L3.95856927,26.5789651 C3.95856927,26.8911266 4.21191771,27.144475 4.52407917,27.144475 L9.04815834,27.144475 C9.36031981,27.144475 9.61366824,26.8911266 9.61366824,26.5789651 L9.61366824,21.4893761 L13.0067276,21.4893761 C13.3188891,21.4893761 13.5722375,21.2360276 13.5722375,20.9238662 C13.5722375,14.8989237 10.5908693,10.1791781 6.78611876,10.1791781 C2.98136817,10.1791781 0,14.8989237 0,20.9238662 Z",
    id: "Fill-3093"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(8.263045, 3.290008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.94517404,13.2602321 C13.601683,13.2602321 16.5752901,10.286625 16.5752901,6.63011603 C16.5752901,2.97360704 13.601683,0 9.94517404,0 C6.28866505,0 3.31505801,2.97360704 3.31505801,6.63011603 C3.31505801,10.286625 6.28866505,13.2602321 9.94517404,13.2602321",
    id: "Fill-3092"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94517404,14.9177611 C4.36924646,14.9177611 0,21.8346296 0,30.6642866 C0,31.1217646 0.371286498,31.4930511 0.828764503,31.4930511 L5.80135152,31.4930511 L5.80135152,38.9519317 C5.80135152,39.4094097 6.17263802,39.7806962 6.63011603,39.7806962 L13.2602321,39.7806962 C13.7177101,39.7806962 14.0889966,39.4094097 14.0889966,38.9519317 L14.0889966,31.4930511 L19.0615836,31.4930511 C19.5190616,31.4930511 19.8903481,31.1217646 19.8903481,30.6642866 C19.8903481,21.8346296 15.5211016,14.9177611 9.94517404,14.9177611",
    id: "Fill-3093"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    opacity: 0.7,
    transform: "translate(33.281532, 5.126040)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2602321,5.30409282 C13.2602321,2.37888563 10.8813464,0 7.95613923,0 C5.03093204,0 2.65204641,2.37888563 2.65204641,5.30409282 C2.65204641,8.22930001 5.03093204,10.6081856 7.95613923,10.6081856 C10.8813464,10.6081856 13.2602321,8.22930001 13.2602321,5.30409282 Z",
    id: "Fill-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.663011603,11.9342088 C0.297029198,11.9342088 0,12.231238 0,12.5972205 C0,18.9992605 2.76210634,21.7772791 4.64108122,22.9256152 L4.64108122,31.1615453 C4.64108122,31.5275277 4.93811042,31.8245569 5.30409282,31.8245569 L10.6081856,31.8245569 C10.974168,31.8245569 11.2711972,31.5275277 11.2711972,31.1615453 L11.2711972,22.9256152 C13.1501721,21.7772791 15.9122785,18.9979345 15.9122785,12.5972205 C15.9122785,12.231238 15.6152493,11.9342088 15.2492669,11.9342088 L0.663011603,11.9342088 Z",
    id: "Fill-13"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.3101979,4.52407917 C11.3101979,2.02904951 9.28114842,0 6.78611876,0 C4.29108909,0 2.26203959,2.02904951 2.26203959,4.52407917 C2.26203959,7.01910883 4.29108909,9.04815834 6.78611876,9.04815834 C9.28114842,9.04815834 11.3101979,7.01910883 11.3101979,4.52407917 Z",
    id: "Fill-3092",
    opacity: 0.4
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGroupOfPeopleYellow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/group_of_people_yellow.ce3516b0a654dbd316a0e8fa808f09b7.svg";